import React from 'react';
import { motion } from 'framer-motion';
import { Blocks, Target, Settings, UserCircle, LineChart, Shield } from 'lucide-react';
export function ModulesBreakdown() {
  const modules = [{
    icon: <Blocks className="w-8 h-8 text-gold-400" data-id="element-106" />,
    title: 'Módulo 1: Fundamentos',
    desc: 'Entiende exactamente cómo funciona el sistema de comisiones, qué plataformas usar según tu nicho y cómo posicionarte desde el día uno para convertir.'
  }, {
    icon: <Target className="w-8 h-8 text-gold-400" data-id="element-107" />,
    title: 'Módulo 2: Estrategias de Promoción',
    desc: 'Marketing de Contenido, Publicidad en Redes Sociales y Email Marketing. Aprende a crear ecosistemas que atraen, educan y venden sin parecer vendedor.'
  }, {
    icon: <Settings className="w-8 h-8 text-gold-400" data-id="element-108" />,
    title: 'Módulo 3: Herramientas y Automatización',
    desc: 'Descubre las herramientas exactas para rastrear tus enlaces, automatizar tu seguimiento y escalar sin trabajar el doble de horas.'
  }, {
    icon: <UserCircle className="w-8 h-8 text-gold-400" data-id="element-109" />,
    title: 'Módulo 4: Marca Personal como Coach',
    desc: 'Aprende a definir tu nicho con precisión quirúrgica, crear contenido que posiciona y hacer networking que abre puertas.'
  }, {
    icon: <LineChart className="w-8 h-8 text-gold-400" data-id="element-110" />,
    title: 'Módulo 5: Métricas y Optimización',
    desc: 'Aprende a leer tus datos, interpretar las métricas que importan y ajustar tu estrategia con precisión.'
  }, {
    icon: <Shield className="w-8 h-8 text-gold-400" data-id="element-111" />,
    title: 'Módulo 6: Ética y Reputación',
    desc: 'El activo más valioso en el marketing de afiliados no es tu tráfico — es tu reputación. Aprende a construirla y protegerla.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-112">
      <div className="max-w-6xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-114">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-115">
            ¿Qué Encuentras <span className="text-gold-400" data-id="element-116">Dentro?</span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-117">
            El mapa completo, dividido en 6 módulos accionables.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-118">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="bg-navy-900/50 border border-white/5 hover:border-gold-500/30 p-8 rounded-2xl transition-all duration-300 group" data-id="element-119">
              <div className="mb-6 p-4 bg-navy-800 inline-block rounded-xl border border-white/5 group-hover:border-gold-500/20 group-hover:bg-navy-800/80 transition-colors" data-id="element-120">
                {mod.icon}
              </div>
              <h3 className="text-2xl font-serif text-white mb-4" data-id="element-121">
                {mod.title}
              </h3>
              <p className="text-slate-300 leading-relaxed font-light" data-id="element-122">
                {mod.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}